import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { token } from "../helper/constant";
import secureLocalStorage from "react-secure-storage";
const ProtectedRoute = ({ children }) => {
  const [storedToken, setStoredToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = secureLocalStorage.getItem(
      process.env.REACT_APP_TOKEN_STORAGE_KEY
    );
    setStoredToken(token);
  }, []);

  useEffect(() => {
    if (storedToken == null) {
      navigate("/login");
    }
  }, [storedToken]);
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
